import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
import { PageHeader } from '../PageHeader';
import { useApp } from '../store';
export function NewsPage() {
  const {
    articles
  } = useApp();
  const [active, setActive] = useState('All');
  const categories = ['All', ...Array.from(new Set(articles.map(a => a.category)))];
  const filtered = active === 'All' ? articles : articles.filter(a => a.category === active);
  const [hero, ...rest] = filtered;
  return <>
      <PageHeader title="News" subtitle="Company updates, announcements, and stories." data-id="element-488" />

      {/* Category filter */}
      <div className="flex flex-wrap gap-2 mb-6" data-id="element-489">
        {categories.map(c => <button key={c} onClick={() => setActive(c)} className={`px-3.5 py-1.5 rounded-full text-sm font-semibold transition-colors ${active === c ? 'bg-navy-600 text-white' : 'bg-white text-navy-600 border border-navy-100 hover:border-gold-400'}`} data-id="element-490">
            {c}
          </button>)}
      </div>

      {hero && <Link to={`/news/${hero.id}`} className="block group mb-8" data-id="element-491">
          <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} className="grid md:grid-cols-2 gap-6 bg-white rounded-2xl border border-navy-100 overflow-hidden" data-id="element-492">
            <div className="h-56 md:h-auto overflow-hidden" data-id="element-493">
              <img src={hero.image} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-494" />
            </div>
            <div className="p-6 flex flex-col justify-center" data-id="element-495">
              <span className="text-xs font-bold uppercase tracking-widest text-gold-600 mb-2" data-id="element-496">
                {hero.category}
              </span>
              <h2 className="text-2xl font-serif font-bold text-navy-900 leading-tight mb-2 group-hover:text-gold-600 transition-colors" data-id="element-497">
                {hero.title}
              </h2>
              <p className="text-navy-600 text-sm leading-relaxed mb-4" data-id="element-498">
                {hero.excerpt}
              </p>
              <div className="flex items-center gap-2 text-xs text-navy-400" data-id="element-499">
                <img src={hero.authorAvatar} alt="" className="w-6 h-6 rounded-full" data-id="element-500" />
                <span className="font-medium text-navy-700" data-id="element-501">{hero.author}</span>
                <span data-id="element-502">·</span>
                <span data-id="element-503">{hero.date}</span>
                <span className="inline-flex items-center gap-1 ml-auto" data-id="element-504">
                  <Clock className="w-3 h-3" data-id="element-505" />
                  {hero.readTime}
                </span>
              </div>
            </div>
          </motion.div>
        </Link>}

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-506">
        {rest.map((a, i) => <motion.div key={a.id} initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.05
      }} data-id="element-507">
            <Link to={`/news/${a.id}`} className="block group bg-white rounded-xl border border-navy-100 overflow-hidden h-full hover:shadow-md transition-shadow" data-id="element-508">
              <div className="h-40 overflow-hidden" data-id="element-509">
                <img src={a.image} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-510" />
              </div>
              <div className="p-4" data-id="element-511">
                <span className="text-[0.7rem] font-bold uppercase tracking-wide text-gold-600" data-id="element-512">
                  {a.category}
                </span>
                <h3 className="text-base font-serif font-bold text-navy-900 leading-snug mt-1 mb-2 group-hover:text-gold-600 transition-colors" data-id="element-513">
                  {a.title}
                </h3>
                <div className="flex items-center gap-1.5 text-xs text-navy-400" data-id="element-514">
                  <span data-id="element-515">{a.date}</span>
                  <span data-id="element-516">·</span>
                  <span data-id="element-517">{a.readTime}</span>
                </div>
              </div>
            </Link>
          </motion.div>)}
      </div>
    </>;
}